module.exports = __webpack_public_path__ + "img/client_logos.2cd905f7.png";